import * as APIRoutes from '@mm/api-routes';
import { ContactVariable } from '../interfaces/contacts';
import AttributeModel from '../model/AttributeModel';
import AuthenticatedController from './AuthenticatedController';

type AttributePostResponse = {
  errors: string[];
  success: boolean;
  variable: {
    id: number;
    name: string;
    created_at: string;
  };
};

export default class AttributeController extends AuthenticatedController {
  static async getAll(pageId: number): Promise<AttributeModel[]> {
    const response = await super.get(APIRoutes.FACEBOOK_PAGE_VARIABLES(pageId));
    return response.map(attribute => ({
      ...attribute,
      system: attribute.system || false,
      settable: attribute.settable || false,
      webhooksOnly: attribute.webhooksOnly || false,
    }));
  }

  static async retrieveBusinessAttributes(
    facebookPageId: number,
  ): Promise<AttributeModel[]> {
    const response = await super.get(
      APIRoutes.FACEBOOK_PAGE_BUSINESS_VARIABLES(facebookPageId),
    );

    return response;
  }

  static postAttribute(
    facebookPageId: number,
    entity: { name: string },
  ): Promise<AttributePostResponse> {
    return super.post(APIRoutes.CREATE_ATTRIBUTE(facebookPageId), entity);
  }

  static async deleteAttribute(attributeId: number) {
    return super.delete(APIRoutes.DELETE_ATTRIBUTE(attributeId));
  }

  static async addAttribute(
    contactId: number,
    attributeName: string,
    attributeValue: string,
  ): Promise<ContactVariable> {
    return super.post(`${APIRoutes.CONTACTS}/${contactId}/variable_values`, {
      contactId,
      name: attributeName,
      value: attributeValue,
    });
  }

  static async deleteVariableValue(attributeId: number) {
    return super.delete(APIRoutes.DELETE_FB_VARIABLE_VALUE(attributeId));
  }
}
